import axios from "@axios";
import Swal from 'sweetalert2';

export default {
  namespaced: true,
  state: {
    events: [],
    selectedEvent: {},
    calendarOptions: [
      {
        color: "danger",
        label: "Staff",
      },
      {
        color: "primary",
        label: "Students",
      },
      {
        color: "warning",
        label: "Parents",
      },
      // {
      //   color: "success",
      //   label: "Holiday",
      // },
      // {
      //   color: "info",
      //   label: "ETC",
      // },
    ],
    selectedCalendars: ["Staff", "Students", "Parents"], //"Holiday", "ETC"
  },
  getters: {},
  mutations: {
    SET_EVENTS(state, eventsData) {
      state.events = eventsData.map(item => {
        const evt = item.events;
        const eventColor = state.calendarOptions.find(opt => opt.label === evt.eventFor)?.color || 'primary';
        
        return {
          id: evt.id,
          title: evt.title,
          start: evt.start,
          end: evt.end,
          color: eventColor,
          extendedProps: {
            calendar: evt.eventFor,
            description: evt.description || '',
            location: evt.location || '',
            eventLink: evt.locationLink || '',
            startTime: evt.startTime || '',
            endTime: evt.endTime || '',
            classID: evt.clsIDs ? evt.clsIDs.split(',').map(Number).filter(Boolean) : [],
            secID: evt.secIDs ? evt.secIDs.split(',').map(Number).filter(Boolean) : [],
            departmentID: evt.departmentIDs ? evt.departmentIDs.split(',').map(Number).filter(Boolean) : [],
            contactPhone: evt.contactPhone || '',
            attachments: item.attachments || []
          }
        };
      });
    },

    UPDATE_EVENT(state, event) {
      state.events = state.events.map(e => e.id === event.id ? event : e);
    },

    REMOVE_EVENT(state, eventId) {
      state.events = state.events.filter(e => e.id !== eventId);
    },

    SET_SELECTED_EVENT(state, event) {
      state.selectedEvent = event;
    },

    SET_SELECTED_EVENTS(state, val) {
      state.selectedCalendars = val;
    },
  },
  actions: {
    fetchEvents() {
      // This is now handled by the Calendar component directly
      return Promise.resolve();
    },

    updateEvent({ commit }, event) {
      commit('UPDATE_EVENT', event);
    },

    async removeEvent({ commit, rootState, dispatch }, { id, context }) {
      try {
        // Show confirmation dialog
        const result = await Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          confirmButtonText: "Yes, delete it!"
        });

        if (!result.isConfirmed) {
          return { success: false, cancelled: true };
        }

        // Use the generic delete method from store
        const status = await dispatch('delete', {
          url: `${rootState.domain}EventsCalendar/${id}?db=${rootState.userData.db}&cID=${rootState.userData.cId}`,
          token: rootState.userData.token,
          message: "Event deleted successfully",
          context: context,
          grading: true // This prevents the generic delete method from showing its own toast
        }, { root: true });

        if (status) {
          commit('REMOVE_EVENT', id);
          return { success: true, cancelled: false };
        }
        return { success: false, cancelled: false };
      } catch (error) {
        console.error('❌ Error deleting event:', error);
        return { success: false, cancelled: false };
      }
    },

    addEvent(ctx, { event }) {
      return new Promise((resolve, reject) => {
        axios
          .post("/apps/calendar/events", { event })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
  },
};

